// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3233f0f8] .ant-form-item {\n  display: flex;\n}\n[data-v-3233f0f8] .ant-form-item .ant-form-item-control-wrapper {\n  flex: 1;\n}", ""]);
// Exports
module.exports = exports;
